import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HolLoginComponent } from './hol-login/HolLoginComponent';
import { HolRegisterComponent } from './hol-register/HolRegisterComponent';
import { HolChoosePasswordComponent } from './hol-register/HolChoosePasswordComponent';
import { HolForgotPasswordComponent } from './hol-forgot-password/HolForgotPasswordComponent';
import { HolChangePasswordComponent } from './hol-change-password/HolChangePasswordComponent';
import { HolSetNewPasswordComponent } from './hol-forgot-password/HolSetNewPasswordComponent';

import { LoginComponent } from './login/LoginComponent';
import { LogoutComponent } from './logout/LogoutComponent';
import { RegisterComponent } from './register/RegisterComponent';
import { ChoosePasswordComponent } from './register/ChoosePasswordComponent';
import { ForgotPasswordComponent } from './forgot-password/ForgotPasswordComponent';
import { SetNewPasswordComponent } from './forgot-password/SetNewPasswordComponent';
import { ChangePasswordComponent } from './change-password/ChangePasswordComponent';
import { AddParentComponent } from './parent/AddParentComponent';
import { AddStudentComponent } from './student/AddStudentComponent';

const userRoutes: Routes = [
    { 
        path: 'register',
        component: RegisterComponent
    },
    { 
        path: 'hol-register',
        component: HolRegisterComponent
    },
    {
        path: 'choose-password/:token',
        component: ChoosePasswordComponent
    },
    {
        path: 'hol-choose-password/:recovery',
        component: HolChoosePasswordComponent
    },
	{
        path: 'login',
        component: LoginComponent
    },
	{
        path: 'hol-login',
        component: HolLoginComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    },
    { 
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    { 
        path: 'hol-forgot-password',
        component: HolForgotPasswordComponent
    },
    { 
        path: 'hol-forgot-password/:token',
        component: HolForgotPasswordComponent
    },
    {
        path: 'forgot-password/:token',
        component: SetNewPasswordComponent
    },
    {
        path: 'change-password',
        component: ChangePasswordComponent
    },
    {
        path: 'hol-change-password',
        component: HolChangePasswordComponent
    },
    {
        path: 'add-parent',
        component: AddParentComponent
    },
    {
        path: 'add-student',
        component: AddStudentComponent
    },
];

export const userRouting: ModuleWithProviders = RouterModule.forChild(userRoutes);


// WEBPACK FOOTER //
// ./src/common/modules/user/UserRouting.ts